import type { MarkupTierDraft } from "./rateCardPreview";

function num(v: string | null | undefined): number {
    if (v == null || v === "") return NaN;
    const n = Number(v);
    return Number.isFinite(n) ? n : NaN;
}

/** Remove junk/invalid bands and keep a single open-ended tier at the end. */
export function sanitizeMarkupTiers(tiers: MarkupTierDraft[]): MarkupTierDraft[] {
    const valid: MarkupTierDraft[] = [];
    for (const t of tiers) {
        const min = num(t.min_amount);
        if (!Number.isFinite(min) || min < 0) continue;
        const maxRaw = t.max_amount;
        const max = maxRaw == null || maxRaw === "" ? null : num(maxRaw);
        if (max != null && Number.isFinite(max)) {
            if (max < min) continue;
            if (min === 0 && max === 0) continue;
        }
        valid.push(t);
    }

    valid.sort((a, b) => num(a.min_amount) - num(b.min_amount));

    const openIdx: number[] = [];
    for (let i = 0; i < valid.length; i++) {
        const max = valid[i]!.max_amount;
        if (max == null || max === "") openIdx.push(i);
    }
    if (openIdx.length > 1) {
        const keep = openIdx[openIdx.length - 1]!;
        return valid.filter((_, i) => {
            const max = valid[i]!.max_amount;
            const isOpen = max == null || max === "";
            return !isOpen || i === keep;
        });
    }

    return valid.map((t, idx) => ({ ...t, sort_order: idx }));
}

export function tiersToApiPayload(tiers: MarkupTierDraft[]) {
    return sanitizeMarkupTiers(tiers).map((t, idx) => ({
        minAmount: Number(t.min_amount),
        maxAmount: t.max_amount == null || t.max_amount === "" ? null : Number(t.max_amount),
        multiplier: Number(t.multiplier),
        sortOrder: t.sort_order ?? idx,
    }));
}
